import { Dispatch } from 'redux';
import { axiosInstance, request, requestConfig } from './base';
import { AtivarDesativarParametrizacoesRequest, CommandResultTyped } from 'common/genericTypes';
import { ParametrizacoesResponse } from 'store/modules/parametrizacoes/parametrizacoesResponse';

export const GETParametrizacoes = async (dispatch: Dispatch, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<CommandResultTyped<ParametrizacoesResponse[]>>(`${requestConfig.api}api/v1/parametrizacoes`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTAtivarDesativarParametrizacoes = async (
  dispatch: Dispatch,
  ativarDesativarParametrizacao: Array<AtivarDesativarParametrizacoesRequest>,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.put<any>(`${requestConfig.api}api/v1/parametrizacoes`, ativarDesativarParametrizacao),
    dispatch,
    undefined,
    stackRequest
  );
};
